import { nextTick as b } from "vue";
import { match as h } from "./index342.js";
import { getOwnerDocument as f } from "./index343.js";
let m = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var x = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(x || {}), y = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(y || {}), p = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(p || {});
function E(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(m)).sort((t, r) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (r.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var w = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(w || {});
function O(e, t = 0) {
  var r;
  return e === ((r = f(e)) == null ? void 0 : r.body) ? !1 : h(t, { 0() {
    return e.matches(m);
  }, 1() {
    let o = e;
    for (; o !== null; ) {
      if (o.matches(m)) return !0;
      o = o.parentElement;
    }
    return !1;
  } });
}
function D(e) {
  let t = f(e);
  b(() => {
    t && !O(t.activeElement, 0) && I(e);
  });
}
var S = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(S || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function I(e) {
  e?.focus({ preventScroll: !0 });
}
let A = ["textarea", "input"].join(",");
function M(e) {
  var t, r;
  return (r = (t = e?.matches) == null ? void 0 : t.call(e, A)) != null ? r : !1;
}
function L(e, t = (r) => r) {
  return e.slice().sort((r, o) => {
    let l = t(r), i = t(o);
    if (l === null || i === null) return 0;
    let a = l.compareDocumentPosition(i);
    return a & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : a & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function K(e, t) {
  return P(E(), t, { relativeTo: e });
}
function P(e, t, { sorted: r = !0, relativeTo: o = null, skipElements: l = [] } = {}) {
  var i;
  let a = (i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e?.ownerDocument) != null ? i : document, n = Array.isArray(e) ? r ? L(e) : e : E(e);
  l.length > 0 && n.length > 1 && (n = n.filter((u) => !l.includes(u))), o = o ?? a.activeElement;
  let v = (() => {
    if (t & 5) return 1;
    if (t & 10) return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), F = (() => {
    if (t & 1) return 0;
    if (t & 2) return Math.max(0, n.indexOf(o)) - 1;
    if (t & 4) return Math.max(0, n.indexOf(o)) + 1;
    if (t & 8) return n.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), N = t & 32 ? { preventScroll: !0 } : {}, d = 0, c = n.length, s;
  do {
    if (d >= c || d + c <= 0) return 0;
    let u = F + d;
    if (t & 16) u = (u + c) % c;
    else {
      if (u < 0) return 3;
      if (u >= c) return 1;
    }
    s = n[u], s?.focus(N), d += v;
  } while (s !== a.activeElement);
  return t & 6 && M(s) && s.select(), 2;
}
export {
  x as Focus,
  y as FocusResult,
  w as FocusableMode,
  I as focusElement,
  K as focusFrom,
  P as focusIn,
  E as getFocusableElements,
  O as isFocusableElement,
  D as restoreFocusIfNecessary,
  L as sortByDomNode
};
